/**
 * Created by r4zi4l on 05.04.2024
 */

Reward.register("cards", {
    countable: true,
    flyingAnimation: Reward.SPAWN_CARDS_ANIMATION,

    getIcon: function () {
        return bundles.reward_icons.frames.cards;
    },

    receive: function (value) {
        if (!this.spawnedCards) {
            this.spawnedCards = [];
        }

        for (let i = 0; i < value; ++i) {
            const card = TileFactory.Create({}, {
                noMarks: true
            });

            this.spawnedCards.push(card);
        }

        return function () {

        };
    }
});
